<template>
<div class="grid">
<div class="col-12 mt-4">
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-else>
  <!-- multiple calculation -->
  <template v-if="$store.state.evaluation.evaluation.flow.questionlist.multiple_calculations">
    <template v-if="data.flowsupplier.customquizresults.length">
      <div class="grid" v-for="result in data.flowsupplier.customquizresults">
        <div class="col-12">
          <h4 class="text-primary">{{result.calculation.name}}</h4>
        </div>

        <div class="col-2">
        <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.puan}}:</p>
        </div>
        <div class="col-10">
          <p class="text-primary mt-0">{{result.points.toFixed(2)}}</p>
        </div>


        <template v-if="result.calculation.customattribute && result.calculation.customattribute.supplierattributes.length">
          <div class="col-2">
          <p class="font-bold mt-0">{{getTheTranslation(result.calculation.customattribute,"translation")}}:</p>
          </div>
          <div class="col-10">
            <template v-if="result.calculation.customattribute.type=='select'">
              <p class="mt-0 font-bold" v-html="getOptionData(result.calculation.customattribute.options,result.calculation.customattribute.supplierattributes[0].attibutenumericalval)"></p>
            </template>
          </div>          
        </template>

      </div>
    </template>
    <template>
      <p class="text-red-600 font-bold">Aşama henüz tamamlanmadı</p>
    </template>
  </template>
   <!-- multiple calculation -->
   <!-- single calculation -->
  <template v-else>
    <template v-if="data.quizresult">
    <div class="grid">

    <div class="col-3">
    <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.puan}}:</p>
    </div>

    <div class="col-9">
    <p class=" mt-0">
    <span class="text-green-500 font-bold">{{data.quizresult.percentage_over_points}} / {{data.quizresult.points.toFixed(2)}}</span>

    </p>
    </div>

    <div class="col-3">
    <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.basari_yuzdesi}}:</p>
    </div>

    <div class="col-9">
    <p class=" mt-0">

    <span class="text-primary  font-bold">{{data.quizresult.percentage}}%</span>
    </p>
    </div>

    <div class="col-12">
      <hr>
    <div class="grid"  v-for="item in flowsupplierattributes">
    <div class="col-4"><p class="click_edit_value_title">{{item.customattribute.name}}:</p></div>
    <div class="col-8">

    <template v-if="item.customattribute.type=='select'">
      <p class="click_edit_value" :style="'color:#'+getAttributeVal(item).color">{{getAttributeVal(item).name}}</p>
    </template>

    <template v-if="item.customattribute.type=='number'">
      <p class="click_edit_value" >{{item.attibutenumericalval}}</p>
    </template>

    <template v-if="item.customattribute.type=='string'">
      <p class="click_edit_value" >{{item.attibutetextval}}</p>
    </template>


    </div>
    

    </div>

    </div>


    </div>
    </template>

    <template v-else>
      <p class="text-red-600 font-bold">Aşama henüz tamamlanmadı</p>
    </template>
  </template>
  <!-- single calculation -->
  
</template>



</div>
</div>



</template>

<script>
export default {

  name: 'AuditReport',

  data () {
    return {
      data:null,
      loading:true,
      recalculating:false,
      flowsupplierattributes:[],
      requiredcertificates:[],
      exemptioncertificates:[],
      nonconformities:[],
      nonconformity_types:[],
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"karne") 
    this.getData()
  },
  methods:{
    getOptionData(options,id)
    {
      let item = options.find(item=>item.id == id)
      if(item)
      {
        if(item.color)
        {
          return "<span style='color:#"+item.color+"'>"+this.getTheTranslation(item,"translation")+"</span>"
        }
        else
        {
          return "<span class='text-primary'>"+this.getTheTranslation(item,"translation")+"</span>"
        }
      }
      return null
    },
    getAttributeVal(item)
    {
      console.log(item)
      let options = item.customattribute.options
      if(options)
      {
        let option = options.find((element)=>{return element.id == item.attibutenumericalval})
        if(option)
        {
          return {
            name:option.name,
            color:option.color
          }
        }
      }
      return {
        name:"-",
        color:"000"
      }
    },
    async  pdfoUTPUT()
    {
      
      var doc = new jsPDF('p', 'pt', 'A4');
      let  margins = {
            top: 80,
            bottom: 60,
            left: 40,
            width: 522
        };
      doc.html(this.$refs.testHtml, {
         callback: function (doc) {
           doc.save();
         },
         x: 10,
         y: 10
      });
      

    },
    async recalculate(flowsupplier_uuid)
    {
      this.recalculating = await true
      let data = await this.generalApiGetWithoutLoader("audit/recalculate_flowsupplier_data/"+flowsupplier_uuid)
      console.log(data)
      this.data.quizresult = await data
      this.recalculating = await false
    },
    documentUpdated(data)
    {
      this.data.uploaded_certificates = data
      this.resolveUploadedCertificates()
    },
    resolveUploadedCertificates()
    {
      let uploaded_certificates = this.data.uploaded_certificates
      let requiredcertificates = this.requiredcertificates
      let exemptioncertificates = this.exemptioncertificates


      for(let requiredcertificate of requiredcertificates)
      {
        requiredcertificate.documents = []
        requiredcertificate.upload_status = 0
      }

      for(let exemptioncertificate of exemptioncertificates)
      {
        exemptioncertificate.documents = []
        exemptioncertificate.upload_status = 0
      }

      for(let uploaded_certificate of uploaded_certificates)
      {
        let exampmatch = exemptioncertificates.findIndex((item)=>{return item.certificatetype_id == uploaded_certificate.certificatetype_id})
        if(exampmatch!==-1)
        {
          exemptioncertificates[exampmatch].documents.push(uploaded_certificate)
        }

        let reqmatch = requiredcertificates.findIndex((item)=>{return item.certificatetype_id == uploaded_certificate.certificatetype_id})
        if(reqmatch!==-1)
        {
          requiredcertificates[reqmatch].documents.push(uploaded_certificate)
        }

      }

      
      for (let i = 0; i < requiredcertificates.length; i++)
      {
        for (let ii = 0; ii < requiredcertificates[i].documents.length; ii++)
        {
          if(requiredcertificates[i].documents[ii].status=="accepted")
          {
            requiredcertificates[i].upload_status = 1            
          }
        }
        
      }

      for (let i = 0; i < exemptioncertificates.length; i++)
      {
        for (let ii = 0; ii < exemptioncertificates[i].documents.length; ii++)
        {
          if(exemptioncertificates[i].documents[ii].status=="accepted")
          {
            exemptioncertificates[i].upload_status = 1            
          }
        }
      }



      this.requiredcertificates = requiredcertificates
      this.exemptioncertificates = exemptioncertificates

    },
    async getData()
    {
      this.loading = await true
      //console.log(this.$store.state.audit)
      this.data = await this.generalApiGetWithoutLoader("audit/get_flow_summary_data_for_audit/"+this.$route.params.audit_uuid) 
      console.log("AUDİT");
      console.log(this.data)
       
      let supplierattributes = this.data.flowsupplier.supplier.supplierattributes
      for(let flowattribute of this.data.flowsupplier.flow.flowattributes)
      {
        let the_att = await supplierattributes.find((item)=>{return item.customattribute_id == flowattribute.customattribute_id})
        if(the_att)
        {
          await this.flowsupplierattributes.push(the_att)
        }
       
      }
      
      let requiredcertificates = await []
      let exemptioncertificates = await []      
      this.nonconformities = this.data.nonconformities
      this.nonconformity_types = this.data.nonconformity_types
      
      //loop requiredcertificates
      for(let requiredcertificate of this.data.flowsupplier.flow.requiredcertificates)
      {
        let element = await requiredcertificates.findIndex((item)=>{return item.certificatetype_id == requiredcertificate.certificatetype_id})
        if(element==-1)
        {
          await requiredcertificates.push(requiredcertificate)
        }
      }
      //loop requiredcertificates

      //loop exemptioncertificate
      for(let exemptioncertificate of this.data.flowsupplier.flow.exemptioncertificates)
      {
        let element = await exemptioncertificates.findIndex((item)=>{return item.certificatetype_id == exemptioncertificate.certificatetype_id})
        if(element==-1)
        {
          await exemptioncertificates.push(exemptioncertificate)
        }
      }
      //loop exemptioncertificate

      
      

      for(let requiredcertificate of requiredcertificates)
      {
        let element = await exemptioncertificates.find((item)=>{return item.certificatetype_id == requiredcertificate.certificatetype_id })
        console.log(element)
        if(element)
        {
          requiredcertificates = await requiredcertificates.filter((item)=>{return item.certificatetype_id !== element.certificatetype_id})
        }
      }

      this.exemptioncertificates = await exemptioncertificates
      this.requiredcertificates = await requiredcertificates

      await this.resolveUploadedCertificates()

      console.log(this.flowsupplierattributes)
      this.loading = await false
    },
    gotoActiveFlow(uuid)
    {            
      console.log(this.data)
      if(this.data.flowsupplier.flow.type=='audit' && this.data.flowsupplier.audit) 
      {
        this.$router.push({ name: 'AuditCover', params: { audit_uuid:this.data.flowsupplier.audit.uuid } })
      }
      else
      {
        this.$router.push({ name: 'Evaluation', params: { id:uuid } })
      }
      
    },
  }
}
</script>

<style lang="css" scoped>
</style>